import h from 'react-hyperscript';
import {Component} from 'react';
import './Avatar.scss';
import Image from 'Components/Image/Image';

class Avatar extends Component {
  render() {
    return (
      h('a', {
        href: '#',
        className: 'avatar__container',
        id: this.props.id,
        onClick: this.props.onClick,
      }, h(Image, {
        src: this.props.image,
        className: 'avatar',
        alt: 'Avatar icon',
      }, null))
    );
  }
}

export default Avatar;
